import React from 'react';
import { View, TouchableOpacity, StyleSheet, ViewPropTypes, Platform, Dimensions } from 'react-native'

import PropTypes from 'prop-types';

import { Icon, VFText } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../FrameworkTestKeys';
import { getThemeImages } from '../../../Themes';

import styles from './AddCard.Styles';

const AddCard = ({ onPress, text, containerStyle, isValidTopupNumber = true }) => {
  const theme = useTheme();
  const Images = getThemeImages(theme.name);
  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <View style={[styles.container, containerStyle]}>
        <TouchableOpacity
          onPress={onPress}
          disabled={!isValidTopupNumber}
          style={[
            StyleSheet.absoluteFillObject,
            styles.container,
            styles.addCard(theme, isValidTopupNumber)
          ]}
          testID="topUpAddCardBtn"
        >
          <VFText i18nKey={text} style={styles.addCardText(isValidTopupNumber)} />
          <Icon type="image" size={32} name={Images.ic_payment_red} style={[!isValidTopupNumber && { tintColor: '#CCCCCC' }]} />
        </TouchableOpacity>
      </View>
    )
  }
  return (
    <View style={[styles.container, containerStyle]}>
      <TouchableOpacity
        onPress={onPress}
        style={[StyleSheet.absoluteFillObject, styles.container, styles.addCard(theme)]}
        testID={FrameworkTestKeys.TopUpAddCardBtn}
      >
        <VFText i18nKey={text} style={styles.addCardText} type="tertiary" />
        <Icon type="image" size={32} name={Images.ic_payment_red} />
      </TouchableOpacity>
    </View>
  );
};

AddCard.propTypes = {
  text: PropTypes.string,
  onPress: PropTypes.func,
  containerStyle: ViewPropTypes.style,
};

export default AddCard;
